export const priceSurveyColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Cidade', value: 'city' },
  { label: 'Data da pesquisa', value: 'survey_conducted_at' },
  { label: 'Ações', value: 'actions', className: 'w-10' },
]
